module.exports = __webpack_public_path__ + "static/media/imageAddIcon.e83004a9.svg";